'use client';

import { motion } from 'motion/react';

const FAQ_ITEMS = [
  {
    q: 'Is it secure?',
    a: 'Yes, admin-only edits. Viewers have read-only access via public links.',
  },
  { q: 'What devices work?', a: 'Any browser-enabled device: phones, tablets, laptops, and TVs.' },
  { q: 'Can I use offline?', a: 'Not yet, but Wi-Fi is assumed on set for the best experience.' },
  {
    q: "How's latency?",
    a: 'Pre-downloads ensure precision. Assets are ready before you trigger.',
  },
] as const;

export function LandingFaq() {
  return (
    <section
      id="faq"
      className="scroll-mt-20 border-t border-[var(--landing-border)] py-24 px-4"
      aria-labelledby="faq-heading"
    >
      <div className="mx-auto max-w-6xl">
        <motion.h2
          id="faq-heading"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-heading text-center text-3xl font-bold text-white md:text-4xl"
        >
          FAQ
        </motion.h2>

        <div className="mt-12 space-y-2">
          {FAQ_ITEMS.map((item, i) => (
            <details
              key={i}
              className="group overflow-hidden rounded-xl border border-[var(--landing-border)] bg-white/[0.04] transition-colors hover:border-[var(--landing-border)]"
            >
              <summary className="flex w-full cursor-pointer list-none items-center justify-between gap-3 px-5 py-4 text-left font-medium text-white hover:bg-white/[0.04] focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[var(--landing-accent-blue)] [&::-webkit-details-marker]:hidden">
                {item.q}
                <svg
                  className="h-5 w-5 shrink-0 transition-transform group-open:rotate-180"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </summary>
              <div className="px-5 pb-4 pt-0 text-[var(--landing-muted)]">{item.a}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
